<template lang="pug">
.time-range
  .ampm(:style="`font-size: ${pxToRem(fs1)}`")
    .cn {{$t(`date.${ampm}`)}}
    .en {{ampm.toUpperCase()}}
  .range(:style="`font-size: ${pxToRem(fs2)}`") {{range}}
  
</template>
<script>
export default {
  name: 'TimeRange',
  props: {
    fs1: {},
    fs2: {},
    schedule: {},
  },
  data() {
    return {}
  },
  computed: {
    ampm() {
      if (!this.schedule) return ''
      return this.schedule.from.getHours() >= 12 ? 'pm' : 'am'
    },
    range() {
      if (!this.schedule) return ''
      let h1 = this.schedule.from.getHours()
      let m1 = this.schedule.from.getMinutes()
      let h2 = this.schedule.to.getHours()
      let m2 = this.schedule.to.getMinutes()
      return `${h1 >= 10 ? '' : '0'}${h1}:${m1 >= 10 ? '' : '0'}${m1}-${
        h2 >= 10 ? '' : '0'
      }${h2}:${m2 >= 10 ? '' : '0'}${m2}`
    },
  },
  methods: {
    pxToRem(px) {
      return px * 0.01 + 'rem'
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.time-range
  width: 100%
  display: flex
  align-items: center
  flex-direction: row
  color: inherit
  .ampm
    //font-size: pxToRem(30)
    text-align: center
  .range
    //font-size: pxToRem(90)
    white-space: nowrap
    font-weight: bold
    font-family: $ff-number
    margin-left: pxToRem(20)
</style>
